import { StationsState } from '../../types';

export const resetSelectedStation = (
  state: StationsState
) => ({
  ...state,
  selectedStation: {}
});
